export function SET_PERMISSIONS (state, data) {
    state.permissions = data.permissions
}